/* eslint-disable no-param-reassign */

import { types } from "mobx-state-tree";
import PremiumModel from "./premium";

import { notification } from "antd";
import ApiService from "services/api";

const ContactModel = types
  .model("ContactModel", {
    id: types.number,
    firstName: types.maybeNull(types.string),
    dateOfBirth: types.maybeNull(types.string),
    timeOfBirth: types.maybeNull(types.string),
    placeOfBirth: types.maybeNull(types.string),
    gender: types.maybeNull(types.string),
    maritalStatus: types.maybeNull(types.string),
    spentCreditsCount: types.maybeNull(types.number),
    transactionsLevel: types.maybeNull(types.string),
    photos: types.array(
      types.model({
        id: types.string,
        thumbImage: types.maybeNull(types.string),
        mediumImage: types.maybeNull(types.string),
        title: types.maybeNull(types.string),
        createdAt: types.maybeNull(types.string),
      })
    ),
    premiumPurchases: types.array(PremiumModel),
    notes: types.maybeNull(
      types.array(
        types.model({
          id: types.number,
          content: types.maybeNull(types.string),
          isCommon: types.maybeNull(types.boolean),
          createdAt: types.maybeNull(types.string),
        })
      )
    ),
  })
  .actions((self) => ({
    getNotes() {
      ApiService.getNotes(self.id)
        .then(({ data }) => self.setNotes(data))
        .catch(() => notification.error({ message: "Failed to load notes" }));
    },

    getPremiums() {
      ApiService.getPremiumPurchases(self.id)
        .then(({ data }) => self.setPremiumPurchases(data))
        .catch(() => {
          notification.error({ message: "Failed to load premium purchases" });
        });
    },

    getPhotos() {
      ApiService.getPhotos(self.id)
        .then(({ data }) => self.setPhotos(data))
        .catch(() => notification.error({ message: "Failed to load photos" }));
    },

    setNotes(notes) {
      self.notes = notes;
      return self;
    },

    setPhotos(photos) {
      self.photos = photos;
      return self;
    },

    setPremiumPurchases(premiums) {
      self.premiumPurchases = premiums;
      return self;
    },

    addNote(note) {
      self.notes = [self.notes[0], note, ...self.notes.slice(1)].filter(
        (i) => i
      );
      return self;
    },

    updateNote(note) {
      self.notes = self.notes.map((v) => (v.id == note.id ? note : v));
      return self;
    },

    updatePremiumPurchase(newPremium) {
      const premium = self.premiumPurchases.find((v) => v.id == newPremium.id);
      if (premium) premium.update(newPremium);

      return self;
    },

    addPremiumPurchase(premiumPurchase) {
      self.premiumPurchases = [premiumPurchase, ...self.premiumPurchases];
      return self;
    },
    deleteNote(note) {
      self.notes = self.notes.filter((i) => i.id != note.id);
      return self;
    },
  }))
  .views((self) => ({
    get age() {
      return (
        new Date().getFullYear() - new Date(self.dateOfBirth).getFullYear()
      );
    },
    get soldPremiumPurchases() {
      return self.premiumPurchases.filter((v) => v.status === "sold");
    },
    get nameOrId() {
      return self.firstName || `#${self.id}`;
    },
  }));

export default ContactModel;
